import { SceneManager } from './systems/SceneManager';
import { DEFAULT_CONFIG } from './core/config/SimulationConfig';

const container = document.getElementById('render-container');

if (!container) {
  throw new Error('Render container not found');
}

const sceneManager = new SceneManager(container, DEFAULT_CONFIG);
sceneManager.initialize();

console.log('=== Sandcastle Simulation Started! ===');
console.log('');
console.log('CONTROLS:');
console.log('  [1] = Sand Tool (raise/lower sand)');
console.log('    - Left click + drag = Raise sand');
console.log('    - Right click + drag = Lower sand');
console.log('  [2] = Water Tool (add water)');
console.log('    - Left/Right click + drag = Add water');
console.log('');
console.log('PHYSICS:');
console.log('  - Sand collapses based on angle of repose');
console.log('  - Water flows downhill and erodes sand');
console.log('  - Waves come from the edges');
console.log('');

(window as any).sceneManager = sceneManager;
